import { render, staticRenderFns } from "./dual-column.vue?vue&type=template&id=628ba6d6&scoped=true"
import script from "./dual-column.vue?vue&type=script&lang=ts&setup=true"
export * from "./dual-column.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./dual-column.vue?vue&type=style&index=0&id=628ba6d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ba6d6",
  null
  
)

export default component.exports